import {FocusEvent, useRef, useState} from 'react';

function useHoverCard(delay = 200) {
    const [isVisible, setIsVisible] = useState(false);
    const hideTimeoutRef = useRef<NodeJS.Timeout | null>(null);

    const show = () => {
        if (hideTimeoutRef.current) {
            clearTimeout(hideTimeoutRef.current);
            hideTimeoutRef.current = null;
        }
        setIsVisible(true);
    };

    const handleMouseEnter = () => {
        show();
    };

    const handleMouseLeave = () => {
        hideTimeoutRef.current = setTimeout(() => {
            setIsVisible(false);
        }, delay);
    };

    const handleFocus = () => {
        show();
    };

    const handleBlur = (event: FocusEvent) => {
        if (event.currentTarget.contains(event.relatedTarget as Node)) {
            return;
        }
        handleMouseLeave();
    };

    const hideUserCard = () => setIsVisible(false);

    return {
        isVisible,
        handleMouseEnter,
        handleMouseLeave,
        handleFocus,
        handleBlur,
        hideUserCard
    };
}

export default useHoverCard;
